import { SIGNUS_API_URL } from './constants';
import { extractErrorMessage, fetchWithTokenRefresh } from './apiFetch';

export type PlanType = 'FREE' | 'PRO' | 'STANDARD' | 'ENTERPRISE';

export async function isTeamOnFreePlan(teamSlug: string, accessToken: string): Promise<boolean> {
  const url = `${SIGNUS_API_URL}/v0/teams/${encodeURIComponent(teamSlug)}/billing-plan/summary`;

  const res = await fetchWithTokenRefresh(url, accessToken, token => ({
    headers: { Authorization: token },
  }));

  const json = await res.json();

  if (!res.ok) {
    throw new Error(extractErrorMessage(json, `Failed to load plan (${res.status})`));
  }

  const payload = (json.payload ?? json) as { type?: PlanType };
  return payload.type === 'FREE';
}
